import { Body1, Flex, Stack, Subtitle1 } from "@myphx-engineering/phx-design-system";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/alternative-card/internal/HeaderGroup.tsx
const HeaderGroup = ({ title, description, icon }) => {
	return /* @__PURE__ */ jsxs(Stack, {
		gap: "xxs",
		children: [/* @__PURE__ */ jsxs(Flex, {
			gap: "xxs",
			children: [/* @__PURE__ */ jsx(Subtitle1, { children: title }), icon]
		}), description ? /* @__PURE__ */ jsx(Body1, { children: description }) : null]
	});
};

//#endregion
export { HeaderGroup };